'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('selectPlanController', function (userService, billingService, $scope) {

    $scope.allPlans = [];
    $scope.selectPlanCallback = null;
    $scope.billingDetails = billingService.billingDetails;
    $scope.show = false;

    // Fetch all plans.
    if ($scope.allPlans.length === 0) {
      billingService.getPlans((plans) => {
        $scope.allPlans = plans;
      }, () => {
        $scope.allPlans = [];
      });
    }

    // Generate credit card expiry years
    $scope.cardYears = [];
    var thisYear = moment().year();
    for (var i = 0; i < 10; i++) {
      var newYear = thisYear + i;
      var newYearShort = parseInt(newYear.toString().substr(-2));
      $scope.cardYears.push({ short: newYearShort, full: newYear });
    }


    const featureToText = {
      ordersEnabled: 'view the orders page',
      jobsEnabled: 'view the jobs page',
      reportingEnabled: 'generate reports', // future
      invoicesEnabled: 'generate invoices',  // future
      accountingIntegrationEnabled: 'integrate with accounting software', // future
      ordersCreate: 'create orders',
      jobsCreate: 'create jobs',
      jobsSubcontractorAllocation: 'allocate subcontractors to jobs',
      jobsAllocationsView: 'view the job allocations page',
      docketsCreate: 'create dockets',
      docketsCreateFromJob: 'create dockets from jobs',
      docketsFiling: 'file dockets',
      docketsTimesheetsView: 'view the timesheets page',
      docketsReports: 'generate docket reports',
      docketsCreateBatches: 'create docket batches',
      docketsViewBatches: 'view docket batches',
    }

    $scope.$parent.selectPlan = function (cb, requiredFeature, trackingText) {
      billingService.getBillingDetails(function (billingDetails) {
        $scope.billingDetails = billingDetails;
      });

      mixpanel.track('select plan modal - view');

      if (trackingText) {
        mixpanel.track('select plan modal - ' + trackingText);
      }
      $scope.selectPlanCallback = cb;
      $scope.requiredFeatureText = null;

      $scope.selectPlanConfig = { mode: 'plans', saving: false, updateCardOnly: false };

      $scope.requiredPlan = {};
      const availablePlans = $scope.allPlans.filter(plan => plan.available);

      if (requiredFeature === 'users') {
        userService.getMembers(null, function (users) {
          $scope.requiredPlan = availablePlans.find(plan => plan.features.includedUsers === -1 || plan.features.includedUsers > users.length);

          if ($scope.requiredPlan) {
            $scope.requiredFeatureText = `To add more users, you will need to upgrade to the ${$scope.requiredPlan.name} plan.`
          }
        }, function (err) { })
      } else if (requiredFeature === 'groups') {
        $scope.requiredPlan = availablePlans.find(plan => plan.features.includedOrganisationGroups == 0 || plan.features.includedOrganisationGroups > $scope.currentOrg.groups.length)
        if ($scope.requiredPlan) {
          $scope.requiredFeatureText = `To add create more groups, you will need to upgrade to the ${$scope.requiredPlan.name} plan.`
        }
      }
      else {
        $scope.requiredPlan = availablePlans.find(plan => plan.features[requiredFeature] === 'true')
        if ($scope.requiredPlan) {
          $scope.requiredFeatureText = `To ${featureToText[requiredFeature]}, you will need to upgrade to the ${$scope.requiredPlan.name} plan.`
        }
      }

      $scope.show = true;
    };

    $scope.$parent.selectPlanUpdateCard = function (cb) {
      $scope.selectPlanCallback = cb;
      $scope.selectPlanConfig = { mode: 'card', saving: false, updateCardOnly: true };
      $scope.show = true;
    };

    $scope.closePlanSelect = function () {
      $scope.show = false;
      $scope.selectPlanCallback && $scope.selectPlanCallback(null);
    };

    $scope.selectPlanContinue = function (plan) {
      mixpanel.track("Plan selected - " + plan.name);

      $scope.selectPlanConfig.planSelected = plan;
      $scope.selectPlanConfig.hasCard = false;

      if ($scope.billingDetails.currentCard) {
        $scope.selectPlanConfig.saving = true;
        $scope.finishPlanUpdate();
      } else {
        $scope.selectPlanConfig.mode = 'card';
      }
    };

    $scope.refreshPage = function () {
      window.location.reload();
    };

    $scope.selectCardContinue = function () {
      $scope.selectPlanConfig.hasCard = true;
      $scope.finishPlanUpdate();
    };

    $scope.backToPlans = function () {
      $scope.selectPlanConfig.mode = 'plans';
    };

    $scope.finishPlanUpdate = function () {
      $scope.selectPlanConfig.saving = true;

      var billingObj = {};
      if ($scope.selectPlanConfig.updateCardOnly == false) {
        billingObj.plan = $scope.selectPlanConfig.planSelected.id;
      }
      if ($scope.selectPlanConfig.hasCard) {
        window.Stripe.createToken({
          number: $scope.selectPlanConfig.cardUpdate.creditCardNumber,
          cvc: $scope.selectPlanConfig.cardUpdate.cvc,
          exp_month: $scope.selectPlanConfig.cardUpdate.expiry_month,
          exp_year: $scope.selectPlanConfig.cardUpdate.expiry_year
          //address_zip: $scope.selectPlanConfig.cardUpdate.zip
        }, function (result, responseObj) {
          if (!responseObj.error) {
            billingObj.token = responseObj.id;
            $scope.saveBillingUpdate(billingObj);
          } else {
            $scope.alertService.presentAlert('error', 'Oops.', 'Something went wrong with your card details! Check and try again.');
          }
        });
      } else {
        $scope.saveBillingUpdate(billingObj);
      }
    }

    $scope.saveBillingUpdate = function (billingObj) {
      $scope.selectPlanConfig.mode = 'success';
      $scope.selectPlanConfig.saving = true;
      billingService.updateOrganisationBilling($scope.currentOrg.id, billingObj, function () {
        if (billingObj.plan) {
          ga('send', 'event', 'Plan', 'selected', billingObj.plan);
        }
        $scope.planUpdate = {};
        $scope.selectPlanConfig.saving = false;
      }, function (err) {
        $scope.selectPlanConfig.error = true;
        $scope.selectPlanConfig.saving = false;
      });
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/modals/selectPlanController.js